import { en } from './en';
import { fr } from './fr';
import { nl } from './nl';
import { ar } from './ar';
import { tr } from './tr';

export const translations = {
  en,
  fr,
  nl,
  ar,
  tr,
};

export type TranslationKey = keyof typeof en;
export type Language = keyof typeof translations;
